import { TermsResponse } from '@customTypes/ItemTypes';

interface SetDashboardSettings {
    type: 'EB_DASHBOARD'
    value: boolean
}

interface SetMagentoSettings {
    type: 'MAGENTO'
    value: boolean
}

interface SetCplAccountSettings {
    type: 'CUSTOMER_PORTAL'
    value: boolean
}

export function setEBDashboardSettings(value: boolean):SetDashboardSettings {
    return {
        type: 'EB_DASHBOARD',
        value
    };
}

export function setMagentoSettings(value: boolean):SetMagentoSettings {
    return {
        type: 'MAGENTO',
        value
    };
}

export function setCplAccountSettings(value: boolean):SetCplAccountSettings {
    return {
        type: 'CUSTOMER_PORTAL',
        value
    };
}

export const ACTIVE_PARTNER_NAME = 'ACTIVE_PARTNER_NAME';

export function setActivePartnerName(value: string) {
    return {
        type: ACTIVE_PARTNER_NAME,
        value
    };
}

export const NEXT_INSURANCE_TERMS = 'NEXT_INSURANCE_TERMS';

export function setNextInsuranceTerms(value: Array<TermsResponse>) {
    return {
        type: NEXT_INSURANCE_TERMS,
        value
    };
}

export const LILI_BANKING_TERMS = 'LILI_BANKING_TERMS';

export function setLiliBankingTerms(value: Array<TermsResponse>) {
    return {
        type: LILI_BANKING_TERMS,
        value
    };
}

export const LENDIO_TERMS = 'LENDIO_TERMS';

export function setLendioTerms(value: Array<TermsResponse>) {
    return {
        type: LENDIO_TERMS,
        value
    };
}
